(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9Rn4e", function(module, exports) {

$parcel$export(module.exports, "accordionHandler", function () { return $72daf4f609cb5c7b$export$7026b674877c7577; });
/**
 * Handles accordion opening and closing
 * @param {Object} element - Block
 */ const $72daf4f609cb5c7b$export$7026b674877c7577 = (element)=>{
    const accordions = element.querySelectorAll(".accordion");
    accordions.forEach((accordion, index)=>{
        const header = accordion.querySelector('.accordion-header');
        const display = accordion.querySelector(".accordion-display");
        let height = display.offsetHeight;
        if (document.body.classList.contains('page-overview') || document.body.classList.contains('page-contact')) {
            if (index != 0) display.style.height = 0;
            else {
                display.style.height = `${height}px`;
                accordion.querySelector('.plusminus').classList.toggle('active');
            }
        } else display.style.height = 0;
        header.addEventListener("click", (evt)=>{
            if (!evt.target.classList.contains('plusminus')) accordion.querySelector('.plusminus').classList.toggle('active');
            if (display.offsetHeight == 0) display.style.height = `${height}px`;
            else display.style.height = '0px';
        });
    });
};

});

})();
//# sourceMappingURL=accordions.60ea27d1.js.map
